import cx from 'classnames';
import { FunctionComponent } from 'react';

import classes from './definition-list.module.css';

const BlockDtDd: FunctionComponent<{
  span?: boolean;
  dt: string;
  dd: string;
}> = ({ span = false, dt, dd }) => (
  <div>
    <dt
      className={cx('pt-3', 'text-sm', 'font-extrabold', '', {
        [classes.spanCol]: span,
      })}
    >
      <h3>{dt}</h3>
    </dt>
    <dd
      className={cx('text-sm', '', classes.wrapAnywhere, {
        [classes.spanCol]: span,
      })}
    >
      {dd}
    </dd>
  </div>
);

export default BlockDtDd;
